import validate from "/usr/src/app/content/n3-spas-be7f92d4-8494-4ab8-b189-84f77ffd6df9/b2c-build/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/usr/src/app/content/n3-spas-be7f92d4-8494-4ab8-b189-84f77ffd6df9/b2c-build/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}